'use client';
import { createContext, useContext, useState, useMemo, useEffect } from 'react';

interface SideBarContextProps {
	selectedCategory: string;
	setSelectedCategory: (selectedCategory: string) => void;
};

const SideBarContext = createContext<SideBarContextProps>({
	selectedCategory: 'Sports',
	setSelectedCategory: () => { },
});

export const SideBarContextProvider = ({
	children
}: {
	children: React.ReactNode
}) => {
	const [selectedCategory, setSelectedCategory] = useState('Sports');

	const value = useMemo(() => (
		{
			selectedCategory,
			setSelectedCategory
		}
	), [selectedCategory]);

	return (
		<SideBarContext.Provider value={value}>
			{children}
		</SideBarContext.Provider>
	);
}

export const useSideBarContext = () => useContext(SideBarContext);





